module.exports = __webpack_public_path__ + "static/community-slideshow-01-0b5967654d0796af5ac2c7b2102ff354.jpg";